

















import { defineComponent, reactive, ref, watch } from '@vue/composition-api';
import userConfigHandler from '@/renderer/components/user/compositions/userConfigHandler';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import userValidator from '../compositions/userValidator';
export default defineComponent({
  props: {
    isSaveDisabled: {
      type: Boolean,
      default: false,
    },
    name: String,
  },
  setup(props, context) {
    const formData = reactive({
      nickname: props.name || '',
    });
    const { setBaseInfo } = userConfigHandler();
    const { rules } = userValidator(formData);
    const nameRule = {
      nickname: rules.nickname,
    };
    const nameValidated = ref(true);
    const onSubmit = async () => {
      await setBaseInfo({
        nickname: formData.nickname,
      });
      context.emit('close');
    };
    watch(formData, () => {
      nameValidated.value =
        formData.nickname.length > 0 && formData.nickname.length <= ConstantConfig.nicknameMaxLength;
      context.emit('update:isSaveDisabled', nameValidated.value);
    });
    return {
      ConstantConfig,
      nameRule,
      formData,
      onSubmit,
    };
  },
});
